module.exports = __webpack_public_path__ + "static/Noemie_Malaize-79ff532a1c472bec2a98892941f15c81.webp";